import { render, staticRenderFns } from "./ReSales.vue?vue&type=template&id=0f4ce63c&scoped=true"
import script from "./ReSales.vue?vue&type=script&lang=js"
export * from "./ReSales.vue?vue&type=script&lang=js"
import style0 from "./ReSales.vue?vue&type=style&index=0&id=0f4ce63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ce63c",
  null
  
)

export default component.exports